import { Action } from 'redux';
import { Server } from '../../clients/aasServerClient.generated';

export enum ActionTypeNames {
    FetchTableServers = 'Servers/FetchTableServers',
    FetchTableServersNF = 'Servers/FetchTableServersNF',
    StoreTableServers = 'Servers/StoreTableServers',

    FetchAllServers = 'Servers/FetchAllServers',
    StoreAllServers = 'Servers/StoreAllServers',

    ClearSingleServer = 'Servers/ClearSingleServer',
    FetchSingleServer = 'Servers/FetchSingleServer',
    NewSingleServer = 'Servers/NewSingleServer',
    CopySingleServer = 'Servers/CopySingleServer',
    StoreSingleServer = 'Servers/StoreSingleServer',
    CreateSingleServer = 'Servers/CreateSingleServer',
    SaveSingleServer = 'Servers/SaveSingleServer',
    SavedSingleServer = 'Servers/SavedSingleServer',

    DeleteServers = 'Servers/DeleteServers',
    GenerateNewKeys = 'Servers/GenerateNewKeys',
}

export type ServersAction<T extends ActionTypeNames> = Action<T> & {
    serverHostnames: string[];
};

export type FetchTableServersNFAction = Action<ActionTypeNames.FetchTableServersNF>;

export type FetchTableServersAction = Action<ActionTypeNames.FetchTableServers>;
export type StoreTableServersAction = Action<ActionTypeNames.StoreTableServers> & {
    servers: Server[]
};

export type FetchAllServersAction = Action<ActionTypeNames.FetchAllServers>;
export type StoreAllServersAction = Action<ActionTypeNames.StoreAllServers> & {
    servers: Server[]
};

export type DeleteServersAction = ServersAction<ActionTypeNames.DeleteServers>;
export type GenerateNewKeysAction = ServersAction<ActionTypeNames.GenerateNewKeys>;

export type FetchSingleServerAction = Action<ActionTypeNames.FetchSingleServer> & {
    hostname: string;
};
export type NewSingleServerAction = Action<ActionTypeNames.NewSingleServer>;
export type CopySingleServerAction = Action<ActionTypeNames.CopySingleServer> & {
    hostname: string;
};
export type StoreSingleServerAction = Action<ActionTypeNames.StoreSingleServer> & {
    server: Partial<Server>;
};
export type SaveSingleServerAction = Action<ActionTypeNames.SaveSingleServer> & {
    server: Partial<Server>;
};

export type CreateSingleServerAction = Action<ActionTypeNames.CreateSingleServer> & {
    server: Partial<Server>;
};

export type ClearSingleServerAction = Action<ActionTypeNames.ClearSingleServer>;
export type SavedSingleServerAction = Action<ActionTypeNames.SavedSingleServer>;
